export const actions = JSON.parse(`{
        "actions": [{
            "type": "KICK_OFF",
            "names": {
                "default": "Comienzo",
                "short": "Start"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 300000000,
            "tags": [],
            "state": {
                "time": "0:00",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "KICK_OFF",
                "names": {
                    "default": "Comienzo",
                    "short": "Start"
                },
                "participantId": "GN4F11Q46TYQ2ES",
                "participantType": "TEAM",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 300170000,
            "tags": [],
            "state": {
                "time": "0:17",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNASV5VPQAP1WTH",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNFJ5R6VJCVMVDM",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 300290000,
            "tags": [],
            "state": {
                "time": "0:29",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNBW4SXRJ2PZ970",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 300570000,
            "tags": [],
            "state": {
                "time": "0:57",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Mano"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GN288H3GDX624TE",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 300680000,
            "tags": [],
            "state": {
                "time": "1:08",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 300810000,
            "tags": [],
            "state": {
                "time": "1:21",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNBW4SXRJ2PZ970",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNASV5VPQAP1WTH",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 301200000,
            "tags": [],
            "state": {
                "time": "2:00",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNF8EXMYV0JMFX9",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 305070000,
            "tags": [],
            "state": {
                "time": "8:27",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 305990000,
            "tags": [],
            "state": {
                "time": "9:59",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 307320000,
            "tags": [],
            "state": {
                "time": "12:12",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_ON_GOAL",
            "names": {
                "short": "SG",
                "default": "Tiro a gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 309360000,
            "tags": [],
            "state": {
                "time": "15:36",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_ON_GOAL",
                "names": {
                    "short": "SG",
                    "default": "Tiro a gol"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SAVE_BY_GOALKEEPER",
            "names": {
                "short": "Parada",
                "default": "Para del portero"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 309360000,
            "tags": [],
            "state": {
                "time": "15:36",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Rechazada al vuelo"
                    }
                }
            },
            "subActions": [{
                "type": "SAVE_BY_GOALKEEPER",
                "names": {
                    "short": "Parada",
                    "default": "Para del portero"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 309530000,
            "tags": [],
            "state": {
                "time": "15:53",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GN0Y9VRNPYQCCYJ",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 309530000,
            "tags": [],
            "state": {
                "time": "15:53",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GNBW4SXRJ2PZ970",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_ON_GOAL",
            "names": {
                "short": "SG",
                "default": "Tiro a gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 309600000,
            "tags": [],
            "state": {
                "time": "16:00",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_ON_GOAL",
                "names": {
                    "short": "SG",
                    "default": "Tiro a gol"
                },
                "participantId": "GNASV5VPQAP1WTH",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SAVE_BY_GOALKEEPER",
            "names": {
                "short": "Parada",
                "default": "Para del portero"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 309600000,
            "tags": [],
            "state": {
                "time": "16:00",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Atajada de pie"
                    }
                }
            },
            "subActions": [{
                "type": "SAVE_BY_GOALKEEPER",
                "names": {
                    "short": "Parada",
                    "default": "Para del portero"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_ON_GOAL",
            "names": {
                "short": "SG",
                "default": "Tiro a gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 310190000,
            "tags": [],
            "state": {
                "time": "16:59",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_ON_GOAL",
                "names": {
                    "short": "SG",
                    "default": "Tiro a gol"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SAVE_BY_GOALKEEPER",
            "names": {
                "short": "Parada",
                "default": "Para del portero"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 310190000,
            "tags": [],
            "state": {
                "time": "16:59",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Atajada de pie"
                    }
                }
            },
            "subActions": [{
                "type": "SAVE_BY_GOALKEEPER",
                "names": {
                    "short": "Parada",
                    "default": "Para del portero"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_WIDE",
            "names": {
                "short": "SW",
                "default": "Tiro fuera"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 311170000,
            "tags": [],
            "state": {
                "time": "18:37",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_WIDE",
                "names": {
                    "short": "SW",
                    "default": "Tiro fuera"
                },
                "participantId": "GNF8EXMYV0JMFX9",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 311480000,
            "tags": [],
            "state": {
                "time": "19:08",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 311640000,
            "tags": [],
            "state": {
                "time": "19:24",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Mano"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 311840000,
            "tags": [],
            "state": {
                "time": "19:44",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN2ANDRWQ8C14D4",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SAVE_BY_GOALKEEPER",
            "names": {
                "short": "Parada",
                "default": "Para del portero"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 312060000,
            "tags": [],
            "state": {
                "time": "20:06",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Rechazada al vuelo"
                    }
                }
            },
            "subActions": [{
                "type": "SAVE_BY_GOALKEEPER",
                "names": {
                    "short": "Parada",
                    "default": "Para del portero"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_ON_GOAL",
            "names": {
                "short": "SG",
                "default": "Tiro a gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 312060000,
            "tags": [],
            "state": {
                "time": "20:06",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_ON_GOAL",
                "names": {
                    "short": "SG",
                    "default": "Tiro a gol"
                },
                "participantId": "GN8ZV8EPZG5XGCB",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "HIT_POST",
            "names": {
                "default": "Tiro al poste",
                "short": "HP"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 312070000,
            "tags": [],
            "state": {
                "time": "20:07",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "HIT_POST",
                "names": {
                    "default": "Tiro al poste",
                    "short": "HP"
                },
                "participantId": "GN8ZV8EPZG5XGCB",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 312520000,
            "tags": [],
            "state": {
                "time": "20:52",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNASV5VPQAP1WTH",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GN83ZWDZ46S7RRQ",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 312770000,
            "tags": [],
            "state": {
                "time": "21:17",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_WIDE",
            "names": {
                "short": "SW",
                "default": "Tiro fuera"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 316740000,
            "tags": [],
            "state": {
                "time": "27:54",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_WIDE",
                "names": {
                    "short": "SW",
                    "default": "Tiro fuera"
                },
                "participantId": "GN2ANDRWQ8C14D4",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 316940000,
            "tags": [],
            "state": {
                "time": "28:14",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 319720000,
            "tags": [],
            "state": {
                "time": "32:52",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNBW4SXRJ2PZ970",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GN0Y9VRNPYQCCYJ",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 319920000,
            "tags": [],
            "state": {
                "time": "33:12",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN28D0DTPNQ036S",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SAVE_BY_GOALKEEPER",
            "names": {
                "short": "Parada",
                "default": "Para del portero"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 320330000,
            "tags": [],
            "state": {
                "time": "33:53",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Atajada de pie"
                    }
                }
            },
            "subActions": [{
                "type": "SAVE_BY_GOALKEEPER",
                "names": {
                    "short": "Parada",
                    "default": "Para del portero"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_ON_GOAL",
            "names": {
                "short": "SG",
                "default": "Tiro a gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 320330000,
            "tags": [],
            "state": {
                "time": "33:53",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Cabecera"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_ON_GOAL",
                "names": {
                    "short": "SG",
                    "default": "Tiro a gol"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "CORNER",
            "names": {
                "short": "C",
                "default": "Saque de esquina"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 321350000,
            "tags": [],
            "state": {
                "time": "35:35",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "CORNER",
                "names": {
                    "short": "C",
                    "default": "Saque de esquina"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 321590000,
            "tags": [],
            "state": {
                "time": "35:59",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNBW4SXRJ2PZ970",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GN0Y9VRNPYQCCYJ",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 321950000,
            "tags": [],
            "state": {
                "time": "36:35",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN28D0DTPNQ036S",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 323860000,
            "tags": [],
            "state": {
                "time": "39:46",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GNEA2DB437K3GGX",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 323860000,
            "tags": [],
            "state": {
                "time": "39:46",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GN8ZV8EPZG5XGCB",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "CORNER",
            "names": {
                "short": "C",
                "default": "Saque de esquina"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 324140000,
            "tags": [],
            "state": {
                "time": "40:14",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "CORNER",
                "names": {
                    "short": "C",
                    "default": "Saque de esquina"
                },
                "participantId": "GN28D0DTPNQ036S",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_WIDE",
            "names": {
                "short": "SW",
                "default": "Tiro fuera"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 324190000,
            "tags": [],
            "state": {
                "time": "40:19",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_WIDE",
                "names": {
                    "short": "SW",
                    "default": "Tiro fuera"
                },
                "participantId": "GN288H3GDX624TE",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 324360000,
            "tags": [],
            "state": {
                "time": "40:36",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 324890000,
            "tags": [],
            "state": {
                "time": "41:29",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GN8WZVX9MHY97NE",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNE2661MZM6Z8W5",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 325100000,
            "tags": [],
            "state": {
                "time": "41:50",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 325510000,
            "tags": [],
            "state": {
                "time": "42:31",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GNFJ5R6VJCVMVDM",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 325510000,
            "tags": [],
            "state": {
                "time": "42:31",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GN2ANDRWQ8C14D4",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "OFFSIDE",
            "names": {
                "default": "Fuera de juego",
                "short": "OS"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 325530000,
            "tags": [],
            "state": {
                "time": "42:33",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": [{
                "type": "OFFSIDE",
                "names": {
                    "default": "Fuera de juego",
                    "short": "OS"
                },
                "participantId": "GNCZKSYQQHKA8TH",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "INJURY_TIME",
            "names": {
                "default": "Tiempo añadido",
                "short": "IT"
            },
            "order": 327000000,
            "tags": [],
            "state": {
                "time": "45:00",
                "periodNumber": 1
            },
            "properties": {
                "info": "180000"
            },
            "subActions": []
        }, {
            "type": "VIDEO_ASSISTANT_REFEREE",
            "names": {
                "short": "VAR",
                "default": "Videoarbitraje"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 327580000,
            "tags": [],
            "state": {
                "time": "45:58",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "VAR - Gol"
                    }
                },
                "info": {
                    "names": {
                        "default": "No otorgado"
                    }
                }
            },
            "subActions": [{
                "type": "VIDEO_ASSISTANT_REFEREE",
                "names": {
                    "short": "VAR",
                    "default": "Videoarbitraje"
                },
                "participantId": "GNCZKSYQQHKA8TH",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 327800000,
            "tags": [],
            "state": {
                "time": "46:20",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN10FW3EVYQCTC7",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 327920000,
            "tags": [],
            "state": {
                "time": "46:32",
                "periodNumber": 1
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GN0Y9VRNPYQCCYJ",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GN83ZWDZ46S7RRQ",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 328060000,
            "tags": [],
            "state": {
                "time": "46:46",
                "periodNumber": 1
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "END_OF_PERIOD",
            "names": {
                "short": "End",
                "default": "Final de tiempo"
            },
            "order": 328910000,
            "tags": [],
            "state": {
                "time": "48:11",
                "periodNumber": 1
            },
            "properties": {},
            "subActions": []
        }, {
            "type": "KICK_OFF",
            "names": {
                "default": "Comienzo",
                "short": "Start"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 527000000,
            "tags": [],
            "state": {
                "time": "45:00",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "KICK_OFF",
                "names": {
                    "default": "Comienzo",
                    "short": "Start"
                },
                "participantId": "GNDDXMAJZPWET9S",
                "participantType": "TEAM",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 529300000,
            "tags": [],
            "state": {
                "time": "48:50",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNF8EXMYV0JMFX9",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GN83ZWDZ46S7RRQ",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 529670000,
            "tags": [],
            "state": {
                "time": "49:27",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 531850000,
            "tags": [],
            "state": {
                "time": "53:05",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GNEA2DB437K3GGX",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 531850000,
            "tags": [],
            "state": {
                "time": "53:05",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GN8ZV8EPZG5XGCB",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 531880000,
            "tags": [],
            "state": {
                "time": "53:08",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GN83ZWDZ46S7RRQ",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 531880000,
            "tags": [],
            "state": {
                "time": "53:08",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GNF8EXMYV0JMFX9",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 532580000,
            "tags": [],
            "state": {
                "time": "54:18",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 532800000,
            "tags": [],
            "state": {
                "time": "54:40",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GN0Y9VRNPYQCCYJ",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNEA2DB437K3GGX",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 533830000,
            "tags": [],
            "state": {
                "time": "56:23",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "OFFSIDE",
            "names": {
                "default": "Fuera de juego",
                "short": "OS"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 533900000,
            "tags": [],
            "state": {
                "time": "56:30",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "OFFSIDE",
                "names": {
                    "default": "Fuera de juego",
                    "short": "OS"
                },
                "participantId": "GNFJ5R6VJCVMVDM",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 533960000,
            "tags": [],
            "state": {
                "time": "56:36",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN9SGJ2RVHCGM08",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 534320000,
            "tags": [],
            "state": {
                "time": "57:12",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 534320000,
            "tags": [],
            "state": {
                "time": "57:12",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GNBSSC02YPHKTMP",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 534330000,
            "tags": [],
            "state": {
                "time": "57:13",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GN4HC5YEYR9JPKG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 534330000,
            "tags": [],
            "state": {
                "time": "57:13",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL",
            "names": {
                "default": "Gol",
                "short": "G"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 534920000,
            "tags": ["MAIN"],
            "state": {
                "time": "58:12",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "short": "A",
                        "default": "Asistente"
                    }
                },
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "GOAL",
                "names": {
                    "default": "Gol",
                    "short": "G"
                },
                "participantId": "GNE2661MZM6Z8W5",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "ASSIST",
                "names": {
                    "short": "A",
                    "default": "Asistente"
                },
                "participantId": "GNFJ5R6VJCVMVDM",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "KICK_OFF",
            "names": {
                "short": "KO",
                "default": "Saque tras gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 535800000,
            "tags": [],
            "state": {
                "time": "59:40",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "KICK_OFF",
                "names": {
                    "short": "KO",
                    "default": "Saque tras gol"
                },
                "participantId": "GN8ZV8EPZG5XGCB",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 536520000,
            "tags": [],
            "state": {
                "time": "60:52",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNE2661MZM6Z8W5",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GN2ANDRWQ8C14D4",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 536640000,
            "tags": [],
            "state": {
                "time": "61:04",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNASV5VPQAP1WTH",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 536890000,
            "tags": [],
            "state": {
                "time": "61:29",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GN2ANDRWQ8C14D4",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNFJ5R6VJCVMVDM",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "YELLOW",
            "names": {
                "default": "Amarilla",
                "short": "Y"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 536930000,
            "tags": ["MAIN"],
            "state": {
                "time": "61:33",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "YELLOW",
                "names": {
                    "default": "Amarilla",
                    "short": "Y"
                },
                "participantId": "GN2ANDRWQ8C14D4",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 537350000,
            "tags": [],
            "state": {
                "time": "62:15",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNEX9X8AZFS8EAY",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SAVE_BY_GOALKEEPER",
            "names": {
                "short": "Parada",
                "default": "Para del portero"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 538110000,
            "tags": [],
            "state": {
                "time": "63:31",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Rechazada al vuelo"
                    }
                }
            },
            "subActions": [{
                "type": "SAVE_BY_GOALKEEPER",
                "names": {
                    "short": "Parada",
                    "default": "Para del portero"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_ON_GOAL",
            "names": {
                "short": "SG",
                "default": "Tiro a gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 538110000,
            "tags": [],
            "state": {
                "time": "63:31",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_ON_GOAL",
                "names": {
                    "short": "SG",
                    "default": "Tiro a gol"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 538600000,
            "tags": [],
            "state": {
                "time": "64:20",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNE2661MZM6Z8W5",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "SUBSTITUTION",
            "names": {
                "default": "Cambio",
                "short": "C."
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 538910001,
            "tags": ["MAIN"],
            "state": {
                "time": "64:51",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SUBSTITUTION_IN",
                "names": {
                    "default": "Substitution in: Diogo Jota"
                },
                "participantId": "GN48DAF3M2FP78G",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "SUBSTITUTION_OUT",
                "names": {
                    "default": "Substitution out: Luis Díaz"
                },
                "participantId": "GN0Y9VRNPYQCCYJ",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 539220000,
            "tags": [],
            "state": {
                "time": "65:22",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN28D0DTPNQ036S",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 539860000,
            "tags": [],
            "state": {
                "time": "66:26",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 540160000,
            "tags": [],
            "state": {
                "time": "66:56",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "CORNER",
            "names": {
                "short": "C",
                "default": "Saque de esquina"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 540550000,
            "tags": [],
            "state": {
                "time": "67:35",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "CORNER",
                "names": {
                    "short": "C",
                    "default": "Saque de esquina"
                },
                "participantId": "GN28D0DTPNQ036S",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "CORNER",
            "names": {
                "short": "C",
                "default": "Saque de esquina"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 540850000,
            "tags": [],
            "state": {
                "time": "68:05",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "CORNER",
                "names": {
                    "short": "C",
                    "default": "Saque de esquina"
                },
                "participantId": "GN28D0DTPNQ036S",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 540910000,
            "tags": [],
            "state": {
                "time": "68:11",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GNBSSC02YPHKTMP",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 540910000,
            "tags": [],
            "state": {
                "time": "68:11",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Cabecera"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GN2ANDRWQ8C14D4",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_ON_GOAL",
            "names": {
                "short": "SG",
                "default": "Tiro a gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 541080000,
            "tags": [],
            "state": {
                "time": "68:28",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_ON_GOAL",
                "names": {
                    "short": "SG",
                    "default": "Tiro a gol"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SAVE_BY_GOALKEEPER",
            "names": {
                "short": "Parada",
                "default": "Para del portero"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 541080000,
            "tags": [],
            "state": {
                "time": "68:28",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Rechazada de pie"
                    }
                }
            },
            "subActions": [{
                "type": "SAVE_BY_GOALKEEPER",
                "names": {
                    "short": "Parada",
                    "default": "Para del portero"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 542080000,
            "tags": [],
            "state": {
                "time": "70:08",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 542900000,
            "tags": [],
            "state": {
                "time": "71:30",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GN9SGJ2RVHCGM08",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNCZKSYQQHKA8TH",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 543180000,
            "tags": [],
            "state": {
                "time": "71:58",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNEA2DB437K3GGX",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_WIDE",
            "names": {
                "short": "SW",
                "default": "Tiro fuera"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 544280000,
            "tags": [],
            "state": {
                "time": "73:48",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_WIDE",
                "names": {
                    "short": "SW",
                    "default": "Tiro fuera"
                },
                "participantId": "GNF8EXMYV0JMFX9",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_WIDE",
            "names": {
                "short": "SW",
                "default": "Tiro fuera"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 544290000,
            "tags": [],
            "state": {
                "time": "73:49",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_WIDE",
                "names": {
                    "short": "SW",
                    "default": "Tiro fuera"
                },
                "participantId": "GN48DAF3M2FP78G",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 544620000,
            "tags": [],
            "state": {
                "time": "74:22",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 544950000,
            "tags": [],
            "state": {
                "time": "74:55",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GN8ZV8EPZG5XGCB",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 545360000,
            "tags": [],
            "state": {
                "time": "75:36",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "OFFSIDE",
            "names": {
                "default": "Fuera de juego",
                "short": "OS"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 545660000,
            "tags": [],
            "state": {
                "time": "76:06",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "OFFSIDE",
                "names": {
                    "default": "Fuera de juego",
                    "short": "OS"
                },
                "participantId": "GNE2661MZM6Z8W5",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SUBSTITUTION",
            "names": {
                "default": "Cambio",
                "short": "C."
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 545910002,
            "tags": ["MAIN"],
            "state": {
                "time": "76:31",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SUBSTITUTION_IN",
                "names": {
                    "default": "Substitution in: Naby Keïta"
                },
                "participantId": "GN1F35FGVNSJH04",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "SUBSTITUTION_OUT",
                "names": {
                    "default": "Substitution out: Jordan Henderson"
                },
                "participantId": "GN288H3GDX624TE",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "SUBSTITUTION",
            "names": {
                "default": "Cambio",
                "short": "C."
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 546080003,
            "tags": ["MAIN"],
            "state": {
                "time": "76:48",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SUBSTITUTION_IN",
                "names": {
                    "default": "Substitution in: Roberto Firmino"
                },
                "participantId": "GN9PS5AK9SE3K4P",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "SUBSTITUTION_OUT",
                "names": {
                    "default": "Substitution out: Thiago"
                },
                "participantId": "GNASV5VPQAP1WTH",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "CHANGE_OF_CAPTAIN",
            "names": {
                "default": "Cambio de capitán"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 546110000,
            "tags": [],
            "state": {
                "time": "76:51",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "CHANGE_OF_CAPTAIN",
                "names": {
                    "default": "Cambio de capitán"
                },
                "participantId": "GN9SGJ2RVHCGM08",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 546230000,
            "tags": [],
            "state": {
                "time": "77:03",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN8WZVX9MHY97NE",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 546960000,
            "tags": [],
            "state": {
                "time": "78:16",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GNBW4SXRJ2PZ970",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 546960000,
            "tags": [],
            "state": {
                "time": "78:16",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GN9PS5AK9SE3K4P",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "OFFSIDE",
            "names": {
                "default": "Fuera de juego",
                "short": "OS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 547230000,
            "tags": [],
            "state": {
                "time": "78:43",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "OFFSIDE",
                "names": {
                    "default": "Fuera de juego",
                    "short": "OS"
                },
                "participantId": "GN9PS5AK9SE3K4P",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 547650000,
            "tags": [],
            "state": {
                "time": "79:25",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_BLOCKED_BY",
            "names": {
                "default": "Tiro bloqueado por el"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 547840000,
            "tags": [],
            "state": {
                "time": "79:44",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SHOT_BLOCKED_BY",
                "names": {
                    "default": "Tiro bloqueado por el"
                },
                "participantId": "GNDDXMAJZPWET9S",
                "participantType": "TEAM",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "BLOCKED_SHOT",
            "names": {
                "default": "Tiro bloqueado",
                "short": "BS"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 547840000,
            "tags": [],
            "state": {
                "time": "79:44",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "BLOCKED_SHOT",
                "names": {
                    "default": "Tiro bloqueado",
                    "short": "BS"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_ON_GOAL",
            "names": {
                "short": "SG",
                "default": "Tiro a gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 547950000,
            "tags": [],
            "state": {
                "time": "79:55",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_ON_GOAL",
                "names": {
                    "short": "SG",
                    "default": "Tiro a gol"
                },
                "participantId": "GN48DAF3M2FP78G",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SAVE_BY_GOALKEEPER",
            "names": {
                "short": "Parada",
                "default": "Para del portero"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 547950000,
            "tags": [],
            "state": {
                "time": "79:55",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Rechazada al vuelo"
                    }
                }
            },
            "subActions": [{
                "type": "SAVE_BY_GOALKEEPER",
                "names": {
                    "short": "Parada",
                    "default": "Para del portero"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "CORNER",
            "names": {
                "short": "C",
                "default": "Saque de esquina"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 548090000,
            "tags": [],
            "state": {
                "time": "80:09",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "CORNER",
                "names": {
                    "short": "C",
                    "default": "Saque de esquina"
                },
                "participantId": "GNF8EXMYV0JMFX9",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_WIDE",
            "names": {
                "short": "SW",
                "default": "Tiro fuera"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 548580000,
            "tags": [],
            "state": {
                "time": "80:58",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_WIDE",
                "names": {
                    "short": "SW",
                    "default": "Tiro fuera"
                },
                "participantId": "GN1F35FGVNSJH04",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_ON_GOAL",
            "names": {
                "short": "SG",
                "default": "Tiro a gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 549170000,
            "tags": [],
            "state": {
                "time": "81:57",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_ON_GOAL",
                "names": {
                    "short": "SG",
                    "default": "Tiro a gol"
                },
                "participantId": "GNDQN42PHXRK59C",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SAVE_BY_GOALKEEPER",
            "names": {
                "short": "Parada",
                "default": "Para del portero"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 549170000,
            "tags": [],
            "state": {
                "time": "81:57",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Rechazada al vuelo"
                    }
                }
            },
            "subActions": [{
                "type": "SAVE_BY_GOALKEEPER",
                "names": {
                    "short": "Parada",
                    "default": "Para del portero"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "CORNER",
            "names": {
                "short": "C",
                "default": "Saque de esquina"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 549430000,
            "tags": [],
            "state": {
                "time": "82:23",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "CORNER",
                "names": {
                    "short": "C",
                    "default": "Saque de esquina"
                },
                "participantId": "GNF8EXMYV0JMFX9",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SUBSTITUTION",
            "names": {
                "default": "Cambio",
                "short": "C."
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 551010004,
            "tags": ["MAIN"],
            "state": {
                "time": "85:01",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SUBSTITUTION_IN",
                "names": {
                    "default": "Substitution in: Eduardo Camavinga"
                },
                "participantId": "GN7YY37NCVYX73E",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "SUBSTITUTION_OUT",
                "names": {
                    "default": "Substitution out: Federico Valverde"
                },
                "participantId": "GNFJ5R6VJCVMVDM",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "OFFSIDE",
            "names": {
                "default": "Fuera de juego",
                "short": "OS"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 552150000,
            "tags": [],
            "state": {
                "time": "86:55",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "OFFSIDE",
                "names": {
                    "default": "Fuera de juego",
                    "short": "OS"
                },
                "participantId": "GNE2661MZM6Z8W5",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 552280000,
            "tags": [],
            "state": {
                "time": "87:08",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN28D0DTPNQ036S",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "CORNER",
            "names": {
                "short": "C",
                "default": "Saque de esquina"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 552580000,
            "tags": [],
            "state": {
                "time": "87:38",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "CORNER",
                "names": {
                    "short": "C",
                    "default": "Saque de esquina"
                },
                "participantId": "GNF8EXMYV0JMFX9",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 553180000,
            "tags": [],
            "state": {
                "time": "88:38",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GN8WZVX9MHY97NE",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 553260000,
            "tags": [],
            "state": {
                "time": "88:46",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GN2TPAB6NFS6MNG",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SUBSTITUTION",
            "names": {
                "default": "Cambio",
                "short": "C."
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 553570005,
            "tags": ["MAIN"],
            "state": {
                "time": "89:17",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SUBSTITUTION_IN",
                "names": {
                    "default": "Substitution in: Dani Ceballos"
                },
                "participantId": "GNBKABF8AXGVRTJ",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "SUBSTITUTION_OUT",
                "names": {
                    "default": "Substitution out: Luka Modric"
                },
                "participantId": "GNEX9X8AZFS8EAY",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "INJURY_TIME",
            "names": {
                "default": "Tiempo añadido",
                "short": "IT"
            },
            "order": 554010000,
            "tags": [],
            "state": {
                "time": "90:01",
                "periodNumber": 2
            },
            "properties": {
                "info": "300000"
            },
            "subActions": []
        }, {
            "type": "CORNER",
            "names": {
                "short": "C",
                "default": "Saque de esquina"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 554650000,
            "tags": [],
            "state": {
                "time": "91:05",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "CORNER",
                "names": {
                    "short": "C",
                    "default": "Saque de esquina"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SHOT_WIDE",
            "names": {
                "short": "SW",
                "default": "Tiro fuera"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 554830000,
            "tags": [],
            "state": {
                "time": "91:23",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie izquierdo"
                    }
                }
            },
            "subActions": [{
                "type": "SHOT_WIDE",
                "names": {
                    "short": "SW",
                    "default": "Tiro fuera"
                },
                "participantId": "GN7YY37NCVYX73E",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "SUBSTITUTION",
            "names": {
                "default": "Cambio",
                "short": "C."
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 555230006,
            "tags": ["MAIN"],
            "state": {
                "time": "92:03",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "SUBSTITUTION_IN",
                "names": {
                    "default": "Substitution in: Rodrygo"
                },
                "participantId": "GN749GFFDCX0P6J",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "SUBSTITUTION_OUT",
                "names": {
                    "default": "Substitution out: Vinícius Júnior"
                },
                "participantId": "GNE2661MZM6Z8W5",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "GOAL_KICK",
            "names": {
                "short": "GK",
                "default": "Tiro de gol"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 555300000,
            "tags": [],
            "state": {
                "time": "92:10",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": [{
                "type": "GOAL_KICK",
                "names": {
                    "short": "GK",
                    "default": "Tiro de gol"
                },
                "participantId": "GN10FW3EVYQCTC7",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GN4F11Q46TYQ2ES",
            "participantType": "TEAM",
            "order": 555720000,
            "tags": [],
            "state": {
                "time": "92:52",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GN1F35FGVNSJH04",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "FREE_KICK",
            "names": {
                "default": "Tiro libre",
                "short": "TL"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 556150000,
            "tags": [],
            "state": {
                "time": "93:35",
                "periodNumber": 2
            },
            "properties": {
                "info": {
                    "names": {
                        "default": "Pie derecho"
                    }
                }
            },
            "subActions": [{
                "type": "FREE_KICK",
                "names": {
                    "default": "Tiro libre",
                    "short": "TL"
                },
                "participantId": "GNEA2DB437K3GGX",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }]
        }, {
            "type": "FOUL_COMMITTED",
            "names": {
                "default": "Falta cometida",
                "short": "FC"
            },
            "participantId": "GNDDXMAJZPWET9S",
            "participantType": "TEAM",
            "order": 556680000,
            "tags": [],
            "state": {
                "time": "94:28",
                "periodNumber": 2
            },
            "properties": {
                "reason": {
                    "names": {
                        "default": "Jugada violenta"
                    }
                }
            },
            "subActions": [{
                "type": "FOUL_COMMITTED",
                "names": {
                    "default": "Falta cometida",
                    "short": "FC"
                },
                "participantId": "GNES7TREFGP94VK",
                "participantType": "PERSON",
                "order": 0,
                "tags": []
            }, {
                "type": "FOUL_AGAINST",
                "names": {
                    "default": "Foul against"
                },
                "participantId": "GN1F35FGVNSJH04",
                "participantType": "PERSON",
                "order": 1,
                "tags": []
            }]
        }, {
            "type": "END_OF_PERIOD",
            "names": {
                "short": "End",
                "default": "Final de tiempo"
            },
            "order": 557120000,
            "tags": [],
            "state": {
                "time": "95:12",
                "periodNumber": 2
            },
            "properties": {},
            "subActions": []
        }]
}`)


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/actions.ts